<template>
  <o-view class="c-sales-view" :has-white-background="true" :no-scroll="true">
    <o-view :padding-bottom="true">
      <o-nav-bar
        title="Cambio-inschrijving"
        :has-back-button="true"
        :has-close-button="true"
        :is-overlay="true"
      />
      <o-message-header
        icon="warning"
        text="Je inschrijving werd niet aanvaard"
        :error="true"
      />
      <o-section>
        <p>
          Je inschrijving bij Cambio werd niet aanvaard. Meer info hierover kan
          je indien gewenst verkrijgen via de Cambio klantendienst. De eenmalige
          activatiekost is terugbetaald.
        </p>
        <p>
          <a href="#">Contacteer de Cambio klantendienst</a>
        </p>
      </o-section>
    </o-view>
    <o-pay-button label="Sluiten" />
  </o-view>
</template>

<script>
import OMessageHeader from '@/components/OMessageHeader.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'CambioRegistrationRefused',
  components: {
    OMessageHeader,
    OPayButton
  }
}
</script>

<style lang="scss"></style>
